module.exports = __webpack_public_path__ + "static/anchor-9f716079954685439a1fbd2adb401147.png";